import * as React from 'react';

import { cn } from '@/components/TailwindComponents/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    // Normalize controlled value props: if value is explicitly provided but undefined/null,
    // coerce to empty string to avoid uncontrolled→controlled warnings.
    const forwardedProps: React.ComponentProps<'input'> = { ...props };
    if (
      Object.prototype.hasOwnProperty.call(forwardedProps, 'value') &&
      (forwardedProps as any).value == null
    ) {
      (forwardedProps as any).value = '';
    }

    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        ref={ref}
        {...forwardedProps}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
